// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#3A85FF","mainHoverColor":"#415582","bgColor":"#222E4C","bgHoverColor":"#131E37"};